module.exports = __webpack_public_path__ + "img/StaffXmasParty.51ff88dc.png";